import { CheckAccessFunc, GetInvestigationName } from '../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../Utility/ImagePaths';
import { localGetItem } from './Services/CacheProviderService';

export class NewSideMenu {
    static lab = () => {
        // let loginData = localGetItem("loggedInUserInfo");
        // let loginResult = JSON.parse(loginData);
        // let newList = [];
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "Laboratory") {
            if (CheckAccessFunc("Laboratory", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'MainHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("Laboratory", "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'LabReports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
            if (localGetItem('isNewBilling') === 'true') {
                if (CheckAccessFunc("Laboratory", "Lab Billing", null, null, "Menu")?.viewAccess) {
                    newList.push({ id: 6, menuName: 'Lab Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
                }
            }
            if (CheckAccessFunc("Laboratory", "Inventory", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'Inventory', OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            }
            if (CheckAccessFunc("Laboratory", "Purchase", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 4, menuName: 'Purchase', OnIcon: ImagePaths.LabPurchaseOn, OffIcon: ImagePaths.LabPurchaseOff, label: "Purchase" })
            }
            if (CheckAccessFunc("Laboratory", "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: 'SettingsHome', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
            if (UserData?.permission_access?.common?.allow_lab_revert) {
                newList.push({ id: 6, menuName: 'Revert', OnIcon: ImagePaths.Revertonicon, OffIcon: ImagePaths.Revertofficon, label: "Revert" })
            }
        }
        return newList;
    }

    static FO = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var abha_available = JSON.parse(localGetItem("has_abha_service"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        const { common } = UserData?.permission_access;
        let newList = [];

        if (UserData?.module_name === "front_office") {
            if (CheckAccessFunc("front_office", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'OPHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("front_office", "In Patients", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'IPHome', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
            }
            if (localGetItem('isNewBilling') === 'true' && UserData?.enable_radiotherapy && CheckAccessFunc("front_office", "RT WalkIn", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'Radiotherapy Walk In', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "WalkIn" })
            }
            if (localGetItem('isNewBilling') === 'true') {
                if (CheckAccessFunc("front_office", "Hospital Billing", null, null, "Menu")?.viewAccess) {
                    newList.push({ id: 6, menuName: 'Hospital Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Hospital Billing" })
                }
            } else {
                if (CheckAccessFunc("front_office", "Billing", null, null, "Menu")?.viewAccess) {
                    newList.push({ id: 6, menuName: 'Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
                }
            }
            if (CheckAccessFunc("front_office", "Billing Transaction", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'Billing Transaction', OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: 'Billing Transaction' })
            }
            if ((localGetItem('isNewBilling') === 'true') && UserData?.enable_credit_settlement) {
                newList.push({ id: 8, menuName: 'Credit Settlement', OnIcon: ImagePaths.Settlementon, OffIcon: ImagePaths.Settlementoff, label: 'Credit Settlement' })
            }
            if (CheckAccessFunc("front_office", "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 4, menuName: 'FOReports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: 'Reports' })
            }
            if (CheckAccessFunc("front_office", "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: 'Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
            if (UserData?.is_user ? common?.can_view_dashboard === true : true) {
                newList.push({ id: 7, menuName: 'ChartDashboard', OnIcon: ImagePaths.ChartDashboardOn, OffIcon: subscription_expired ? ImagePaths.dashboard_restrict : ImagePaths.ChartDashboardOff, label: "Dashboard" })
            }
            if ((localGetItem('isNewBilling') === 'true') && abha_available && CheckAccessFunc("front_office", "ABDM", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 10, menuName: 'ABDM', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "ABDM" })
            }
            if (UserData?.is_super_admin) {
                newList.push({ id: 8, menuName: 'Revert', OnIcon: ImagePaths.Revertonicon, OffIcon: ImagePaths.Revertofficon, label: "Revert" })
            }
            // if (localGetItem('isNewBilling') === 'true' && CheckAccessFunc("front_office", "Mrd", null, null, "Menu")?.viewAccess) {
            //     newList.push({ id: 9, menuName: 'FO MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: ImagePaths.MRDOffIcon, label: "MRD" })
            // }


        }
        return newList;
    }

    static Nurse = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false")
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "nurse") {
            if (CheckAccessFunc("front_office", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'OPHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("front_office", "In Patients", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'IPHome', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
            }
            if (localGetItem('isNewBilling') === 'true' && UserData?.enable_mrd) {
                newList.push({ id: 3, menuName: 'Doctor MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.MRDOffIcon, label: "MRD" })
            }
        }
        return newList;
    }

    static Pharmacy = () => {
        let myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        let internalStoreEnabled = JSON.parse(localGetItem("internalStoreEnabled"))
        let mainPharmacyEnabled = JSON.parse(localGetItem("mainPharmacyEnabled"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        let UserData = myUser;
        let newList = [];
        let pharmacy_type = UserData?.pharmacy_type === 'Inhouse Pharmacy' ? "Pharmacy" : "Standalone Pharmacy";

        if (UserData?.module_name === 'Pharmacy') {
            if (CheckAccessFunc(pharmacy_type, "Billing", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: "Pharmacy Billing", OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            }
            if (CheckAccessFunc(pharmacy_type, "Billing Transaction", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: "Pharmacy Invoice", OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: "Billing Transaction" })
            }
            if (CheckAccessFunc(pharmacy_type, "Inventory", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: "Pharmacy Inventory", OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            }
            if ((CheckAccessFunc(pharmacy_type, "Purchase", null, null, "Menu")?.viewAccess) && UserData?.is_po_enabled) {
                newList.push({ id: 4, menuName: "Pharmacy Purchase", OnIcon: ImagePaths.LabPurchaseOn, OffIcon: ImagePaths.LabPurchaseOff, label: "Purchase" })
            }
            if (CheckAccessFunc(pharmacy_type, "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: "Pharmacy Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }

            if ((internalStoreEnabled) && (mainPharmacyEnabled) && (CheckAccessFunc(pharmacy_type, "Internal Sales", null, null, "Menu")?.viewAccess)) {
                newList.push({ id: 6, menuName: "Pharmacy Internal Sales", OnIcon: ImagePaths.InternalSalesOn, OffIcon: ImagePaths.InternalSalesOff, label: "Internal Sales" })
            }

            if (UserData?.pharmacy_type === "Inhouse Pharmacy" && CheckAccessFunc("Pharmacy", "Stock Transfer", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 7, menuName: 'Pharmacy Stock Transfer', OnIcon: ImagePaths.StkTransferOn, OffIcon: ImagePaths.StkTransferOff, label: 'Stock Transfer' })
            }
            if (CheckAccessFunc(pharmacy_type, "Settings", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 8, menuName: "Pharmacy Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
            if (UserData?.is_super_admin) {
                newList.push({ id: 9, menuName: "Pharmacy GST Update", OnIcon: ImagePaths.ChartDashboardOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.ChartDashboardOff, label: "GST Update" })
            }
            return newList;
        }
        return newList;
    }

    static SubLocation = () => {
        // const UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        let newList = [];
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 


        // if (UserData?.module_name === 'Pharmacy') {
        if (CheckAccessFunc("sub_location", "Home", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 1, menuName: "SubLocation Billing", OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
        }
        if (CheckAccessFunc("sub_location", "Reports", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: "SubLocation Reports", OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Report" })
        }
        if (CheckAccessFunc("sub_location", "Stock Transfer", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: "SubLocation Stock Transfer", OnIcon: ImagePaths.StkTransferOn, OffIcon: ImagePaths.StkTransferOff, label: "Stock Transfer" })
        }
        return newList;
        // }
    }
    static OT = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 

        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "ot_management") {
            if (true) {
                newList.push({ id: 1, menuName: 'OTHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'OT Billing Transaction', OnIcon: ImagePaths.BillingOn, OffIcon: ImagePaths.BillingOff, label: "Billing Transaction" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'OT Stocks', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "OT Stocks" })
            }
            if (true) {
                newList.push({ id: 3, menuName: 'OT Inventory', OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            }
            if (true) {
                newList.push({ id: 4, menuName: 'OT Stock Transfer', OnIcon: ImagePaths.StkTransferOn, OffIcon: ImagePaths.StkTransferOff, label: "Stock Transfer" })
            }
            if (true) {
                newList.push({ id: 5, menuName: 'OT Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
            if (true) {
                newList.push({ id: 6, menuName: 'OT Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
        }
        return newList;
    }

    static Counsellor = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "counsellor") {
            if (true) {
                newList.push({ id: 1, menuName: 'Counsellor', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOn, label: "Home" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'OTHome', OnIcon: ImagePaths.otListon, OffIcon: ImagePaths.otListoff, label: "OT List" })
            }
        }
        return newList;
    }

    static Doctor = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        let enable_billing = localGetItem('enable_billing') === 'true' ? true : false
        let enable_bill_trans = localGetItem('enable_billing_transaction') === 'true' ? true : false
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 

        if (UserData?.module_name === "Optometry") {
            if (true) {
                newList.push({ id: 1, menuName: 'Doctor Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'Optometry Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
            if (true) {
                newList.push({ id: 3, menuName: 'Optometry Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
        } else if (UserData?.module_name === "Doctor") {
            if (true) {
                newList.push({ id: 1, menuName: 'Doctor Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (UserData?.service_type !== "OPT") {
                newList.push({ id: 7, menuName: 'IP Doctor Home', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
                if (true && enable_billing) {
                    newList.push({ id: 8, menuName: 'Doctor Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: 'Billing' })
                }
                newList.push({ id: 2, menuName: 'Doctor Nutrition Chart', OnIcon: ImagePaths.DocNutritionOn, OffIcon: ImagePaths.DocNutritionOff, label: "Nutrition Chart" })
            }
            if (true && enable_billing && UserData?.service_type === "OPT") {
                newList.push({ id: 8, menuName: 'Doctor Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: 'Billing' })
            }
            if (true && enable_bill_trans) {
                newList.push({ id: 9, menuName: 'Billing Transaction', OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: 'Billing Transaction' })
            }
            if (localGetItem('isNewBilling') === 'true' && UserData?.enable_radiotherapy) {
                newList.push({ id: 10, menuName: 'Radiotherapy Walk In', OnIcon: ImagePaths.WalkinOn, OffIcon: ImagePaths.WalkinOff, label: "WalkIn" })
            }
            if (true) {
                newList.push({ id: 3, menuName: 'Doctor Registry', OnIcon: ImagePaths.DocRegistryOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.DocRegistryOff, label: "Registry" })
            }
            if (localGetItem('isNewBilling') === 'true' && UserData?.enable_mrd) {
                newList.push({ id: 8, menuName: 'Doctor MRD', OnIcon: ImagePaths.MRDOnIcon, OffIcon: subscription_expired ? ImagePaths.dashboard_restrict : ImagePaths.MRDOffIcon, label: "MRD" })
            }
            if (UserData?.is_ot_mapped) {
                newList.push({ id: 4, menuName: 'OTHome', OnIcon: ImagePaths.otListon, OffIcon: ImagePaths.otListoff, label: "OT List" })
            }
            if (UserData?.service_type === "OPT") {
                newList.push({ id: 5, menuName: 'Doctor Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
            if (true) {
                newList.push({ id: 6, menuName: 'Doctor Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
        }
        return newList;
    }

    static Radiology = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        let ModuleName = GetInvestigationName();
        
        // if (UserData?.module_name === ModuleName ) {
        if (CheckAccessFunc(ModuleName, "Home", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 1, menuName: `${GetInvestigationName()}Home`, OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
        }
        if (localGetItem('isNewBilling') === 'true') {
            if (CheckAccessFunc(ModuleName, `${(GetInvestigationName() === "Radiology"  || GetInvestigationName() === 'radiology') ? "Radiology" : "Investigation"} Billing`, null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: `${GetInvestigationName()} Billing`, OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            }
        }
        if (CheckAccessFunc(ModuleName, "Billing Transaction", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: `${GetInvestigationName()} Billing Transaction`, OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: 'Billing Transaction' })
        }
        if (localGetItem('isNewBilling') === 'true') {
            if (CheckAccessFunc(ModuleName, "Order", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 6, menuName: `${GetInvestigationName()} Order`, OnIcon: ImagePaths.OrderOnIcon, OffIcon: ImagePaths.OrderOffIcon, label: 'Order' })
            }
        }
        if (CheckAccessFunc(ModuleName, "Reports", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: `${GetInvestigationName()} Reports`, OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: 'Reports' })
        }
        if (CheckAccessFunc(ModuleName, "Settings", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 4, menuName: `${GetInvestigationName()} Settings`, OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
        }
        return newList;
    }

    static OrganizationAdmin = () => {
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        let newList = [
            ...(localGetItem("isNewBilling") === "false" ? [{ id: 1, menuName: 'AdminDashboard', OnIcon: ImagePaths.ChartDashboardOn, OffIcon: subscription_expired ? ImagePaths.dashboard_restrict : ImagePaths.ChartDashboardOff, label: "Dashboard" }] : []),
            ...(!myUser.is_opt ? [{ id: 3, menuName: 'Login', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: 'Login' }] : []),
            { id: 2, menuName: 'Admin Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" }

        ]
        return newList
    }

    static Asset = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "asset_management") {
            if (true) {
                newList.push({ id: 1, menuName: 'Asset Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'Asset Complaints', OnIcon: ImagePaths.Complaintson, OffIcon: ImagePaths.Complaintsoff, label: "Complaints" })
            }
            if (true) {
                newList.push({ id: 3, menuName: 'Asset Settings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
        }
        return newList;
    }

    static Canteen = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "canteen") {
            if (true) {
                newList.push({ id: 1, menuName: 'CanteenHome', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (true) {
                newList.push({ id: 2, menuName: 'CanteenBillingTransaction', OnIcon: ImagePaths.BillingOn, OffIcon: subscription_expired ? ImagePaths.Billing_restrict : ImagePaths.BillingOff, label: "Billing Transaction" })
            }
            // if (true) {
            //     newList.push({ id: 4, menuName: 'Billing', OnIcon: ImagePaths.BillOn, OffIcon: ImagePaths.BillOff, label: "Billing" })
            // }
            if (true) {
                newList.push({ id: 3, menuName: 'CanteenSettings', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Settings" })
            }
        }
        return newList;
    }

    static JMO = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "JMO") {
            if (true) {
                newList.push({ id: 1, menuName: 'Doctor Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (UserData?.service_type !== "OPT") {
                newList.push({ id: 7, menuName: 'IP Doctor Home', OnIcon: ImagePaths.IpHomeOn, OffIcon: ImagePaths.IpHomeOff, label: "IPHome" })
                newList.push({ id: 2, menuName: 'Doctor Nutrition Chart', OnIcon: ImagePaths.DocNutritionOn, OffIcon: ImagePaths.DocNutritionOff, label: "Nutrition Chart" })
            }
            if (true) {
                newList.push({ id: 3, menuName: 'Doctor Registry', OnIcon: ImagePaths.DocRegistryOn, OffIcon: ImagePaths.DocRegistryOff, label: "Registry" })
            }
            if (UserData?.is_ot_mapped) {
                newList.push({ id: 4, menuName: 'OTHome', OnIcon: ImagePaths.otListon, OffIcon: ImagePaths.otListoff, label: "OT List" })
            }
            if (UserData?.service_type === "OPT") {
                newList.push({ id: 5, menuName: 'Doctor Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Reports" })
            }
        }
        return newList;
    }

    static MRD = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "master_record_department") {
            if (CheckAccessFunc("master_record_department", "Home", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: 'Mrd Home', OnIcon: ImagePaths.LabHomeOn, OffIcon: ImagePaths.LabHomeOff, label: "Home" })
            }
            if (CheckAccessFunc("master_record_department", "Audit Track", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: 'Mrd Audit', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: "Audit Track" })
            }
            if (CheckAccessFunc("master_record_department", "Masters", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'Mrd Masters', OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Masters" })
            }
        }
        return newList;
    }

    static Store = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        const subscription_expired = JSON.parse(localGetItem("subscription_expired") || "false") 
        var UserData = myUser;
        let newList = [];

        if (UserData?.module_name === "store_module") {
            if (CheckAccessFunc("Store", "Purchase", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 1, menuName: "Store Purchase", OnIcon: ImagePaths.LabPurchaseOn, OffIcon: ImagePaths.LabPurchaseOff, label: "Purchase" })
            }
            if (CheckAccessFunc("Store", "Inventory", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 2, menuName: "Store Inventory", OnIcon: ImagePaths.LabInventryOn, OffIcon: ImagePaths.LabInventrytOff, label: "Inventory" })
            }
            if (CheckAccessFunc("Store", "Reports", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 3, menuName: 'Store Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: subscription_expired ? ImagePaths.reports_restrict : ImagePaths.LabReportOff, label: 'Reports' })
            }
            if (CheckAccessFunc("Store", "Masters", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 4, menuName: "Store Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: subscription_expired ? ImagePaths.setting_restrict : ImagePaths.LabSettingOff, label: "Masters" })
            }
            if (CheckAccessFunc("Store", "Store", null, null, "Menu")?.viewAccess) {
                newList.push({ id: 5, menuName: 'Store Transfer', OnIcon: ImagePaths.StoreOnIcon, OffIcon: ImagePaths.StoreOffIcon, label: 'Store' })
            }
        }
        return newList;
    }

    static FO_SubLocation = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (true) {
            newList.push({ id: 1, menuName: "FO Store Transfer", OnIcon: ImagePaths.StoreOnIcon, OffIcon: ImagePaths.StoreOffIcon, label: "Store" })
        }
        return newList;
    }


    static LAB_SubLocation = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (true) {
            newList.push({ id: 1, menuName: "Lab Store Transfer", OnIcon: ImagePaths.StoreOnIcon, OffIcon: ImagePaths.StoreOffIcon, label: "Store" })
        }
        return newList;
    }

    static Radiology_SubLocation = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (true) {
            newList.push({ id: 1, menuName: "Radiology Store Transfer", OnIcon: ImagePaths.StoreOnIcon, OffIcon: ImagePaths.StoreOffIcon, label: "Store" })
        }
        return newList;
    }

    static Pharmacy_SubLocation = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (true) {
            newList.push({ id: 1, menuName: "Pharmacy Store Transfer", OnIcon: ImagePaths.StoreOnIcon, OffIcon: ImagePaths.StoreOffIcon, label: "Store" })
        }
        return newList;
    }

    static Radiotherapy = () => {
        var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
        var UserData = myUser;
        let newList = [];
        if (CheckAccessFunc("Radiotherapy", "Stimulation", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 1, menuName: 'Radiotherapy Stimulation', OnIcon: ImagePaths.SimulatorOn, OffIcon: ImagePaths.StimulationOff, label: "Stimulation" })
        }
        if (CheckAccessFunc("Radiotherapy", "Dosimetrist", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 2, menuName: 'Radiotherapy Dosimetrist', OnIcon: ImagePaths.DosimetristOn, OffIcon: ImagePaths.DosimetristOff, label: "Dosimetrist" })
        }
        if (CheckAccessFunc("Radiotherapy", "Scheduler", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 3, menuName: 'Radiotherapy Scheduler', OnIcon: ImagePaths.SchedulerOn, OffIcon: ImagePaths.SchedulerOff, label: "Scheduler" })
        }
        if (CheckAccessFunc("Radiotherapy", "Therapist", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 4, menuName: 'Radiotherapy Therapist', OnIcon: ImagePaths.TherapistOn, OffIcon: ImagePaths.TherapistOff, label: "Therapist" })
        }
        if (CheckAccessFunc("Radiotherapy", "Reports", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 5, menuName: 'Radiotherapy Reports', OnIcon: ImagePaths.LabReportOn, OffIcon: ImagePaths.LabReportOff, label: 'Reports' })
        }
        if (CheckAccessFunc("Radiotherapy", "Settings", null, null, "Menu")?.viewAccess) {
            newList.push({ id: 6, menuName: "Radiotherapy Setting", OnIcon: ImagePaths.LabSettingOn, OffIcon: ImagePaths.LabSettingOff, label: "Settings" })
        }
        return newList;
    }

}